module.exports = __webpack_public_path__ + "img/medal1.f627e463.png";